import { render, staticRenderFns } from "./ContactChannelsCarousel.vue?vue&type=template&id=dbc9186a&scoped=true&"
import script from "./ContactChannelsCarousel.vue?vue&type=script&lang=js&"
export * from "./ContactChannelsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ContactChannelsCarousel.vue?vue&type=style&index=0&id=dbc9186a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc9186a",
  null
  
)

export default component.exports